import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from '@/components/shared/BottomNav';
import { MobileFrame } from '@/components/shared/MobileFrame';
import { DevBar } from '@/components/shared/DevBar';
import { OfflineBanner } from '@/components/shared/OfflineBanner';
import { ModeBanner } from '@/components/shared/ModeBanner';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { ToastViewport } from '@/components/ui/toast';

export function AtletaLayout() {
    const location = useLocation();
    return (
        <MobileFrame>
            <DevBar />
            <div className="flex flex-col h-dvh md:h-[852px]">
                <ModeBanner />
                <OfflineBanner />
                <main className="flex-1 overflow-y-auto overflow-x-hidden overscroll-contain no-scrollbar">
                    <ErrorBoundary key={location.pathname} variant="page">
                        <Outlet />
                    </ErrorBoundary>
                </main>
                <BottomNav role="atleta" />
            </div>
            <ToastViewport />
        </MobileFrame>
    );
}
